export default __webpack_public_path__ + "static/media/sanathan_logo_white.11853296.png";